import { TextFieldProps } from "@material-ui/core";
import { FieldInputProps } from "formik";
import { observer } from "mobx-react";
import React from "react";
import { THEME } from "../../theme/ThemeStore";

type Props = TextFieldProps & {
    errorMessage?: string;
    field: FieldInputProps<string>;
    isTouched?: boolean;
    width?: string;
    maxAmount: number;
    changeValue(value: number): void;
};

export const CustomNumberField = observer(({ label, field, changeValue, maxAmount }: Props) => {
    const [amount, setAmount] = React.useState(Number(field.value) || 0);

    const increaseAmount = () => {
        if (amount > maxAmount) {
            return;
        }
        changeValue(amount + 1);
        setAmount(amount + 1);
    };
    const decreaseAmount = () => {
        if (amount === 0) {
            return;
        }
        changeValue(amount - 1);
        setAmount(amount - 1);
    };
    return (
        <>
            <div
                style={{
                    flexBasis: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    maxHeight: 56,
                    flexGrow: 1
                }}
                className="customNumberField"
            >
                <div
                    style={{
                        marginLeft: 10,
                        color: THEME.customColors.body1Dark,
                        cursor: "default"
                    }}
                >
                    {label}
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: 10 }}>
                    <SmallButton
                        type="decrease"
                        onClick={() => {
                            decreaseAmount();
                        }}
                        disabled={amount === 0}
                    />

                    <div
                        style={{
                            margin: 10,
                            width: 30,
                            textAlign: "center",
                            cursor: "default"
                        }}
                    >
                        {amount > maxAmount ? `${maxAmount}+` : amount}
                    </div>

                    <SmallButton
                        type="increase"
                        onClick={() => {
                            increaseAmount();
                        }}
                        disabled={amount > maxAmount}
                    />
                </div>
            </div>
            <input
                type="number"
                style={{ display: "none" }}
                value={amount}
                name={field.name}
                onChange={field.onChange}
                onBlur={field.onBlur}
            />
        </>
    );
});

type SmallButtonProps = { onClick: VoidFunction; type: "increase" | "decrease"; disabled: boolean };

const SmallButton = ({ onClick, type, disabled }: SmallButtonProps) => (
    <div
        onClick={onClick}
        style={{
            display: "flex",
            alignItems: "center",
            cursor: disabled ? "auto" : "pointer",
            opacity: disabled ? 0.2 : 1
        }}
    >
        {type === "increase" && <img src={THEME.Images.icPlus} style={{ height: 24, width: 24 }} alt="" />}
        {type === "decrease" && <img src={THEME.Images.icSubtract} style={{ height: 24, width: 24 }} alt="" />}
    </div>
);
